import React, { useState } from "react";
import { message, Alert } from "antd";
import CriticalActionModal from "./CriticalActionModal";
import { reverseCancelSubscription } from "../api/subscriptions/subscriptionsRequest";

/**
 * Feature 1 — Reverse a subscription cancellation (canceled → active).
 */
const ReverseCancelSubscriptionModal = ({ visible, onCancel, onSuccess, subscription }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async (reason) => {
    if (!subscription) return;
    setLoading(true);
    try {
      const response = await reverseCancelSubscription(subscription.id, reason);
      if (response?.success) {
        message.success(response.message || "Annulation inversée avec succès");
        onSuccess?.(response.data);
      } else {
        message.error(response?.message || response?.error || "Erreur lors de l'opération");
      }
    } catch (error) {
      message.error(error.response?.data?.message || error.response?.data?.error || "Erreur lors de l'inversion de l'annulation");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CriticalActionModal
      visible={visible}
      onCancel={onCancel}
      onConfirm={handleConfirm}
      loading={loading}
      title="Inverser l'annulation de l'abonnement"
      okText="Réactiver l'abonnement"
      summaryItems={[
        { label: "Abonnement", to: `#${subscription?.id ?? ""}` },
        { label: "Statut", from: "Annulé", to: "Actif" },
      ]}
      warningBanner={
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 8 }}
          message="Action critique"
          description="Cette action réactivera un abonnement annulé et effacera les informations d'annulation (date, agent, motif)."
        />
      }
    />
  );
};

export default ReverseCancelSubscriptionModal;
